import React from "react";
import Image from "next/image";
import { useTranslation } from "next-i18next";
type ServiceBoxPropsType = { logo: any; title: string; description: string; color: string };

function ServiceBox({ logo, title, description, color }: ServiceBoxPropsType) {
  const { t: translate } = useTranslation("about");

  return (
    <div
      className=" px-6 py-8  rounded-lg grid gap-3 lg:gap-4 "
      style={{ backgroundColor: `${color}0D` }} //0D for 5% opacity
    >
      <Image src={logo} width={50} height={50} alt={translate(title)} />
      <h3 className=" ltr:text-left rtl:text-right font-semibold text-base leading-5 text-indigo">
        {translate(title)}
      </h3>
      <p className="font-normal text-sm lg:leading-7 text-blueGray lg:max-w-[250px] min-h-[120px]">
        {translate(description)}
      </p>
    </div>
  );
}

export default ServiceBox;
